import {
	ReactAlertAction,
	PATIENT_RECENT_ALERTS_ACTION_TYPES,
	PatientRecentAlertsState,
} from '../../../../../types/patientRecentAlerts'

const initialState: PatientRecentAlertsState = {
	alerts: [],
	selectedAlerts: [],
	sortByDate: 'asc',
}

export default (
	state: PatientRecentAlertsState = initialState,
	action: ReactAlertAction
): PatientRecentAlertsState => {
	switch (action.type) {
		case PATIENT_RECENT_ALERTS_ACTION_TYPES.GET: {
			return {
				...state,
				alerts: action.payload,
			}
		}
		case PATIENT_RECENT_ALERTS_ACTION_TYPES.SELECT: {
			const selectedAlertIncludes = state.selectedAlerts.includes(
				action.payload
			)

			if (!selectedAlertIncludes) {
				const updSelectedAlerts = [
					...state.selectedAlerts,
					action.payload,
				]

				return {
					...state,
					selectedAlerts: updSelectedAlerts,
				}
			} else {
				const updSelectedAlerts = state.selectedAlerts.filter(
					alertId => alertId !== action.payload
				)

				return {
					...state,
					selectedAlerts: updSelectedAlerts,
				}
			}
		}
		case PATIENT_RECENT_ALERTS_ACTION_TYPES.SELECT_ALL:{
			if(state.alerts.length === state.selectedAlerts.length){
				return {
					...state,
					selectedAlerts: []
				}
			}else{
				return{
					...state,
					selectedAlerts: action.payload
				}
			}
		}
		case PATIENT_RECENT_ALERTS_ACTION_TYPES.UPDATE: {
			return {
				...state,
				alerts: action.payload,
				selectedAlerts: [],
			}
		}
		case PATIENT_RECENT_ALERTS_ACTION_TYPES.SORT_BY_DATE: {
			return {
				...state,
				sortByDate: action.payload,
			}
		}
		default: {
			return state
		}
	}
}
